var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDinnerGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4972_37206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.3424 21.6667L61.6758 11.6667L63.3424 10V11.6667V50H46.6758V43.3333L48.3424 31.6667L53.3424 21.6667Z",
    fill: "#E3E6ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3337 50V10C47.2803 25.3133 46.5903 37.73 46.667 50H63.3337ZM63.3337 50V70H61.6003V60M26.667 13.3333V70M16.667 13.3333V23.3333C16.667 25.9855 17.7206 28.529 19.5959 30.4044C21.4713 32.2798 24.0148 33.3333 26.667 33.3333C29.3192 33.3333 31.8627 32.2798 33.7381 30.4044C35.6134 28.529 36.667 25.9855 36.667 23.3333V13.3333",
    stroke: "#C8CEDA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4972_37206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDinnerGray);
export default __webpack_public_path__ + "static/media/icon-dinner-gray.7ba83653619cd4cb9d20fa283cb3e39b.svg";
export { ForwardRef as ReactComponent };